import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EFeaturesActionType, IFeaturePropertiesUpdateParameters } from './types';

export const updateFeatureProperties = actionGenerator<
  EFeaturesActionType.FeaturePropertiesUpdated,
  IFeaturePropertiesUpdateParameters
>(EFeaturesActionType.FeaturePropertiesUpdated);
